<script setup lang="ts">
import type { NuxtError } from "#app"

const props = defineProps({
  error: Object as () => NuxtError,
})

const handleError = () => clearError({ redirect: "/" })

// Handle 401 errors by redirecting to login or home
// if (props.error?.statusCode === 401) {
//   await navigateTo("/auth/login")
// }
</script>

<template>
  <main
    v-if="error && error?.statusCode !== 401"
    class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8"
  >
    <div class="text-center">
      <p class="text-base font-semibold text-reader-indigo">
        {{ error?.statusCode }}
      </p>
      <h1
        class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl"
      >
        {{ $t(`errors.${error?.statusCode}.title`) }}
      </h1>
      <p
        class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8"
      >
        {{ $t(`errors.${error?.statusCode}.description`) }}
      </p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <NuxtLink
          to="/"
          class="rounded-lg bg-reader-indigo px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-reader-indigo focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-reader-indigo"
          >{{ $t("common.goBackHome") }}</NuxtLink
        >
        <Popover>
          <PopoverTrigger>
            <Button variant="link" class="text-sm font-semibold text-gray-900"
              >{{ $t("common.contactSupport") }}
              <span aria-hidden="true">&rarr;</span></Button
            >
          </PopoverTrigger>
          <PopoverContent class="space-y-2">
            <h3 class="text-lg font-semibold text-gray-900 mb-2">
              {{ $t("errors.support.title") }}
            </h3>
            <Separator />
            <i18n-t keypath="errors.support.description" tag="p">
              <template #email>
                <a href="mailto:support@chimege.mn" class="text-reader-indigo">support@chimege.mn</a>
              </template>
              <template #phone>
                <a href="tel:+97677401140" class="text-reader-indigo">+976 7740 1140</a>
              </template>
            </i18n-t>
          </PopoverContent>
        </Popover>
      </div>
    </div>
  </main>
</template>
